/** Ticari unvan */
export const BRAND_LEGAL_NAME = "Filiz Dekorasyon Kozmetik";
/** Günlük kullanımda bilinen kısa ad */
export const BRAND_KNOWN_AS = "Filiz Kozmetik";

